import { useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  ContactPerson,
} from "../../../app/slices/contactPersonSlice";
import { Controller, useForm } from "react-hook-form";
import { HiOutlineIdentification, HiOutlineUserCircle } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../components/FormDialog";

const ContactPersonForm = () => {
  const dispatch = useDispatch();
  const _ContactPerson = useSelector(
    (state) => state.contactPerson.contactPerson,
  );
  const _SearchBody = useSelector((state) => state.contactPerson.searchBody);
  const loading = useSelector(
    (state) => state.contactPerson.contactPerson.loading,
  );

  const isAdd = _ContactPerson.form.id ? false : true;

  const { control, handleSubmit, reset } = useForm({
    defaultValues: _ContactPerson.form,
  });

  useEffect(() => {
    reset(_ContactPerson.form);
  }, [_ContactPerson.form, reset]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(ContactPerson.create(data, _SearchBody));
    } else {
      dispatch(ContactPerson.update(data.id, data, _SearchBody));
    }
  };

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_ContactPerson.dialog}
      onClose={handleDialog}
      icon={<HiOutlineUserCircle />}
      title={isAdd ? "إضافة جهة اتصال" : "تعديل جهة اتصال"}
      subtitle={
        isAdd
          ? "أدخل معلومات جهة الاتصال لإضافتها"
          : "قم بتحديث معلومات جهة الاتصال ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
    >
      <SectionCard
        icon={<HiOutlineIdentification />}
        title="معلومات جهة الاتصال"
      >
        <Grid item xs={12} sm={6}>
          <Controller
            name="name"
            control={control}
            rules={{ required: true }}
            render={({ field, fieldState }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                error={!!fieldState.error}
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="mobile_1"
            control={control}
            rules={{ required: true }}
            render={({ field, fieldState }) => (
              <TextField
                required
                size="small"
                label="الهاتف الأول"
                fullWidth
                error={!!fieldState.error}
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="mobile_2"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                label="الهاتف الثاني (اختياري)"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="job_title"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                label="المسمى الوظيفي"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default ContactPersonForm;
